import { formatDate } from '@angular/common';

export class LocalAgendamento {
  constructor(public id: number, public nome: string) {}
}

export class HorariosDisponiveisAgendamento {
  constructor(public id: number, public horario: Date) {}
}

export class FormAgendamento {
  constructor(
    public municipioId: number,
    public dataAgendamento: Date,
    public nome: string,
    public telefone: string,
    public cpf: string
  ) {}
}

export class Agendamento {
  constructor(
    public id: number,
    public ano: number,
    public dataAgendamento: Date,
    public localNome: string
  ) {}

  get protocolo(): string {
    return `${this.id}/${this.ano}`;
  }
}
